import { IAddress, IUSPSResult } from './Domain';
import axios, { AxiosInstance } from "axios";
import { successResponseInterceptor, errorResponseInterceptor } from "../infrastructure/global";
import { getPortalSettings } from "../config/portalSettings";

class USPSClient {
    instance: AxiosInstance;

    constructor()
    {
        this.instance = axios.create({
            baseURL: getPortalSettings().apiHostUrl,
            method: 'get'
        });

        this.instance.interceptors.response.use(
            successResponseInterceptor,
            errorResponseInterceptor
        );
    }

    verifyAddress(address: IAddress): Promise<IUSPSResult> {
        return this.instance.request({
            url: `/d2c/USPS/CheckAddress?zip=${address.zipCode}&state=${address.stateCode}&city=${address.city}&address=${address.street}`,
        }).then((response) => {
            if (response.data.Status === "2") {
                const uspsResult: IUSPSResult = {
                    city: response.data.City,
                    state: response.data.StateProvCd,
                    zip: response.data.PostalCode,
                    street1: response.data.Address1,
                    street2: response.data.Address2
                };

                return uspsResult;
            }
            else
            {
                return Promise.reject(response.data.errorDescription);
            }
        });
    }

    getAreaByZip(zipCode: string): Promise<IUSPSResult> {
        return this.instance.request({
            url: `/d2c/USPS/GetCityStateByZip?zip=${zipCode}`,
        }).then((response) => {
            if (response.data.Status === "2")
            {
                const uspsResult: IUSPSResult = {
                    city: response.data.City,
                    state: response.data.StateCode,
                    zip: response.data.Zip,
                    street1: null,
                    street2: null
                };

                return uspsResult;
            }
            else
            {
                return Promise.reject(response.data.ErrorDescription)
            }
        });
    }
}

export default USPSClient;